import React from "react";
import LegalLayout from "@/components/LegalLayout/LegalLayout";
import { CONTACTS } from "@/constants/contacts";

export default function PrivacidadePage() {
  return (
    <LegalLayout title="Política de Privacidade" testId="privacidade-page">
      <p className="legal-intro">
        Esta Política descreve como tratamos os dados pessoais dos usuários do
        Akali AI, em conformidade com a Lei Geral de Proteção de Dados (Lei nº
        13.709/2018).
      </p>

      <div className="legal-section">
        <h2>1. Identificação do Controlador</h2>
        <p>
          <strong>Fisiopilates Barra Mansa Ltda</strong>, CNPJ
          49.797.203/0001-40, operadora do produto Akali AI, com sede em Barra
          Mansa, RJ.
        </p>
        <p>
          Contato:{" "}
          <a
            href={`mailto:${CONTACTS.privacy}`}
            className="legal-mail"
            data-testid="legal-contact-email"
          >
            {CONTACTS.privacy}
          </a>
        </p>
      </div>

      <div className="legal-section">
        <h2>2. Dados coletados e finalidade</h2>

        <h3>a) Dados de cadastro</h3>
        <p>
          Nome completo, e-mail, especialidade profissional, número de registro
          CREFITO.
          <br />
          <strong>Base legal:</strong> Art. 7, VI da LGPD (execução de
          contrato).
        </p>

        <h3>b) Dados de uso</h3>
        <p>
          Logs de sessão, interações com o sistema, métricas de uso agregadas.
          <br />
          <strong>Base legal:</strong> Art. 7, VI da LGPD (legítimo interesse
          para melhoria do serviço).
        </p>

        <h3>c) Dados clínicos inseridos pelo profissional</h3>
        <p>
          Transcrições de áudio, prontuários gerados.
          <br />
          <strong>Base legal:</strong> Art. 11, II, &quot;f&quot; da LGPD (exercício
          regular de direitos — prestação de serviço ao profissional de saúde
          habilitado).
        </p>
        <p>
          Esses dados são tratados exclusivamente para geração do prontuário
          solicitado pelo profissional e <strong>não são utilizados para
          treinamento de modelos de IA</strong> sem consentimento explícito
          adicional.
        </p>
      </div>

      <div className="legal-section">
        <h2>3. Compartilhamento de dados</h2>
        <p>Os dados são compartilhados exclusivamente com:</p>
        <ul>
          <li>
            <strong>Google LLC (Gemini API)</strong> — processamento de
            linguagem natural para estruturação do prontuário.
          </li>
          <li>
            <strong>Groq Inc. (Whisper API)</strong> — transcrição de áudio em
            português brasileiro.
          </li>
        </ul>
        <p>
          Ambos os fornecedores operam como operadores de dados conforme Art. 37
          da LGPD, com contratos de processamento de dados vigentes.
        </p>
        <p>
          Nenhum dado é vendido, cedido ou compartilhado com terceiros para fins
          comerciais.
        </p>
      </div>

      <div className="legal-section">
        <h2>4. Armazenamento e retenção</h2>
        <p>Dados armazenados em servidores no Brasil.</p>
        <p>
          <strong>Período de retenção:</strong> vigência do contrato + 30 dias
          após cancelamento para possibilitar exportação pelo titular. Após esse
          prazo, exclusão permanente mediante solicitação.
        </p>
      </div>

      <div className="legal-section">
        <h2>5. Direitos do titular (Art. 18 LGPD)</h2>
        <p>
          O titular pode exercer os seguintes direitos mediante solicitação por
          e-mail para{" "}
          <a href={`mailto:${CONTACTS.privacy}`} className="legal-mail">
            {CONTACTS.privacy}
          </a>{" "}
          com prazo de resposta de 15 dias úteis:
        </p>
        <ul>
          <li>Confirmação da existência de tratamento</li>
          <li>Acesso aos dados</li>
          <li>Correção de dados incompletos ou desatualizados</li>
          <li>Anonimização, bloqueio ou eliminação</li>
          <li>Portabilidade dos dados</li>
          <li>Eliminação dos dados tratados com consentimento</li>
          <li>Informação sobre compartilhamento</li>
          <li>Revogação do consentimento</li>
        </ul>
      </div>

      <div className="legal-section">
        <h2>6. Segurança</h2>
        <p>
          Autenticação JWT com isolamento por usuário. Criptografia em trânsito
          (TLS). Logs de auditoria em cada operação de aprovação de prontuário.
          Acesso aos dados restrito a pessoal autorizado mediante necessidade
          operacional.
        </p>
      </div>

      <div className="legal-section">
        <h2>7. Contato e DPO</h2>
        <p>
          <strong>Encarregado de Proteção de Dados:</strong>{" "}
          <a href={`mailto:${CONTACTS.privacy}`} className="legal-mail">
            {CONTACTS.privacy}
          </a>
        </p>
        <p>
          <strong>Autoridade Nacional de Proteção de Dados (ANPD):</strong>{" "}
          <a
            href="https://gov.br/anpd"
            target="_blank"
            rel="noopener noreferrer"
            className="legal-mail"
          >
            gov.br/anpd
          </a>
        </p>
      </div>
    </LegalLayout>
  );
}
